var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "general-details",
      attrs: { "data-cy": "general-details-page" },
    },
    [
      _c(
        "cd-modal",
        {
          staticClass: "modal",
          attrs: {
            "can-cancel": false,
            large: true,
            title: "Don't have a Tax ID?",
            visible: _vm.isModalVisible,
          },
          on: {
            close: function ($event) {
              _vm.isModalVisible = false
            },
            confirm: function ($event) {
              _vm.isModalVisible = false
            },
          },
        },
        [
          _c("p", {
            staticClass: "modal-text",
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("smsRegistrations.generalDetailsWarningModalText")
              ),
            },
          }),
        ]
      ),
      _c("div", { staticClass: "general-details-header" }, [
        _c("h4", [
          _vm._v(_vm._s(_vm.$t("smsRegistrations.generalDetailsHeader"))),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "general-details-form" },
        [
          this.soleProprietorEnabled
            ? _c(
                "VSelect",
                {
                  staticClass: "full-width-field",
                  attrs: {
                    "data-cy": "sms-registration-has-tax-id-select",
                    value: _vm.hasTaxId
                      ? "true"
                      : _vm.hasTaxId === false
                      ? "false"
                      : "",
                    label: _vm.$t("smsRegistrations.taxIdQuestion"),
                    placeholder: "Select an answer",
                    disabled: _vm.isEditView || _vm.readOnly,
                  },
                  on: { input: _vm.hasTaxIdChanged },
                },
                _vm._l(_vm.taxIdOptions, function (option) {
                  return _c("VOption", {
                    key: `tax-id-${option.value}`,
                    attrs: {
                      "data-cy": `tax-id-` + option.value,
                      value: option.value.toString(),
                      text: option.label,
                    },
                  })
                }),
                1
              )
            : _vm._e(),
          _vm.hasTaxId !== undefined
            ? _c("v-divider", {
                staticClass: "divider",
                attrs: { orientation: "horizontal" },
              })
            : _vm._e(),
          _vm.hasTaxId !== undefined
            ? [
                _c(
                  "div",
                  {
                    class: _vm.hasTaxId
                      ? "warning-message-wrapper"
                      : "info-message-wrapper",
                  },
                  [
                    _c("vwc-icon", {
                      class: _vm.hasTaxId ? "warning-icon" : "info-icon",
                      attrs: {
                        type: _vm.hasTaxId ? "warning-line" : "info-line",
                      },
                    }),
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.hasTaxId
                            ? _vm.$t("smsRegistrations.generalDetailsWarning")
                            : _vm.$t(
                                "smsRegistrations.generalDetailsWarningSoleProprietor"
                              )
                        ),
                      },
                    }),
                  ],
                  1
                ),
                _c("text-field", {
                  staticClass: "tex-field",
                  attrs: {
                    disabled: _vm.isEditView || _vm.readOnly,
                    "data-cy": "sms-registration-company-name-input",
                    value: _vm.registrationDetails.companyName,
                    dense: "",
                    label: _vm.hasTaxId
                      ? _vm.$t("smsRegistrations.companyName")
                      : _vm.$t("smsRegistrations.brandName"),
                    placeholder: _vm.hasTaxId
                      ? _vm.$t("smsRegistrations.companyNamePlaceHolder")
                      : _vm.$t("smsRegistrations.brandName"),
                  },
                  on: {
                    textChanged: function ($event) {
                      _vm.registrationDetails.companyName = $event
                    },
                  },
                }),
                _c(
                  "div",
                  { staticClass: "tooltip-wrapper-div" },
                  [
                    _c("text-field", {
                      staticClass: "tex-field",
                      attrs: {
                        disabled: _vm.readOnly,
                        "data-cy": "sms-registration-dba-input",
                        value: _vm.registrationDetails.displayName,
                        dense: "",
                        label: _vm.$t("smsRegistrations.displayName"),
                        placeholder: _vm.$t("smsRegistrations.displayName"),
                      },
                      on: {
                        textChanged: function ($event) {
                          _vm.registrationDetails.displayName = $event
                        },
                      },
                    }),
                    _c("VButton", {
                      attrs: {
                        id: "dba-wrapper-tooltip-anchor",
                        size: "condensed",
                        appearance: "ghost-light",
                        icon: "help-line",
                        connotation: "accent",
                        shape: "rounded",
                      },
                    }),
                    _c("VTooltip", {
                      staticStyle: { "--tooltip-inline-size": "300px" },
                      attrs: {
                        anchor: "dba-wrapper-tooltip-anchor",
                        text: _vm.$t("smsRegistrations.displayNameTooltip"),
                        placement: "left",
                      },
                    }),
                  ],
                  1
                ),
                _vm.hasUsTaxId && _vm.hasTaxId !== false
                  ? _c(
                      "div",
                      { staticClass: "tax-id-wrapper" },
                      [
                        _c("text-field", {
                          staticClass: "tex-field",
                          attrs: {
                            disabled: _vm.isEditView || _vm.readOnly,
                            "data-cy": "sms-registration-ein-tax-id-input",
                            value: _vm.registrationDetails.ein,
                            pattern: _vm.regexPatterns.einPattern,
                            "validation-message": _vm.einErrorMessage,
                            dense: "",
                            label: _vm.$t("smsRegistrations.ein"),
                            placeholder: _vm.$t("smsRegistrations.ein"),
                          },
                          on: {
                            textChanged: function ($event) {
                              _vm.registrationDetails.ein = $event
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm.isCanada
                  ? _c(
                      "div",
                      { attrs: { id: "canada-tax-id-wrapper" } },
                      [
                        _c("text-field", {
                          attrs: {
                            id: "canada-tax-id",
                            disabled: _vm.isEditView || _vm.readOnly,
                            pattern: _vm.regexPatterns.canadaTaxIdPattern,
                            "validation-message": _vm.canadaTaxIdErrorMessage,
                            value: _vm.registrationDetails.ein,
                            dense: "",
                            label: _vm.$t("smsRegistrations.canadaTaxId"),
                          },
                          on: {
                            textChanged: function ($event) {
                              _vm.registrationDetails.ein = $event
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "vwc-select",
                  {
                    staticClass: "text-field",
                    attrs: {
                      disabled: _vm.readOnly,
                      "data-cy": "sms-registration-vertical-type-select",
                      dense: "",
                      required: "",
                      label: _vm.$t("smsRegistrations.vertical"),
                    },
                    on: { selected: _vm.verticalChanged },
                  },
                  _vm._l(_vm.verticalOptions, function (vertical) {
                    return _c(
                      "vwc-list-item",
                      {
                        key: vertical.value,
                        attrs: {
                          selected:
                            vertical.value === _vm.registrationDetails.vertical,
                          value: vertical.label,
                          tabindex: "-1",
                          "aria-disabled": "false",
                          role: "option",
                        },
                      },
                      [_vm._v(_vm._s(vertical.label))]
                    )
                  }),
                  1
                ),
                _vm.hasTaxId
                  ? _c("text-field", {
                      attrs: {
                        disabled: _vm.isEditView || _vm.readOnly,
                        "data-cy": "sms-registration-contact-name-input",
                        value: _vm.registrationDetails.contactName,
                        dense: "",
                        label: _vm.$t("smsRegistrations.contactName"),
                        placeholder: _vm.$t("smsRegistrations.contactName"),
                      },
                      on: {
                        textChanged: function ($event) {
                          _vm.registrationDetails.contactName = $event
                        },
                      },
                    })
                  : _vm._e(),
                _vm.hasTaxId === false
                  ? _c("text-field", {
                      key: "ownerFirstName",
                      staticClass: "text-field",
                      attrs: {
                        disabled: _vm.readOnly,
                        "data-cy": "sms-registration-owner-first-name-input",
                        value: _vm.registrationDetails.firstName,
                        dense: "",
                        label: _vm.$t("smsRegistrations.ownerFirstName"),
                        placeholder: _vm.$t("smsRegistrations.ownerFirstName"),
                      },
                      on: {
                        textChanged: function ($event) {
                          _vm.registrationDetails.firstName = $event
                        },
                      },
                    })
                  : _vm._e(),
                _vm.hasTaxId === false
                  ? _c("text-field", {
                      key: "ownerLastName",
                      staticClass: "text-field",
                      attrs: {
                        disabled: _vm.readOnly,
                        "data-cy": "sms-registration-owner-last-name-input",
                        value: _vm.registrationDetails.lastName,
                        dense: "",
                        label: _vm.$t("smsRegistrations.ownerLastName"),
                        placeholder: _vm.$t("smsRegistrations.ownerLastName"),
                      },
                      on: {
                        textChanged: function ($event) {
                          _vm.registrationDetails.lastName = $event
                        },
                      },
                    })
                  : _vm._e(),
                _c(
                  "vwc-select",
                  {
                    staticClass: "text-field",
                    attrs: {
                      "data-cy": "sms-registration-country-input",
                      required: "",
                      dense: "",
                      disabled: _vm.isEditView || _vm.readOnly,
                      label: _vm.$t("smsRegistrations.country"),
                    },
                    on: { selected: _vm.countryChanged },
                  },
                  _vm._l(_vm.countryOptions, function (country) {
                    return _c(
                      "vwc-list-item",
                      {
                        key: country.label,
                        attrs: {
                          selected:
                            country.value === _vm.registrationDetails.country,
                          value: country.value,
                          tabindex: "-1",
                          "aria-disabled": "false",
                          role: "option",
                        },
                      },
                      [_vm._v(_vm._s(country.label))]
                    )
                  }),
                  1
                ),
                _c(
                  "div",
                  { staticClass: "tooltip-wrapper-div" },
                  [
                    _c(
                      "vlt-field",
                      {
                        staticClass: "phone-field",
                        attrs: {
                          label: _vm.$t("smsRegistrations.phone"),
                          error: _vm.phoneErrorMessage,
                          "data-cy": "phone-number-field",
                        },
                      },
                      [
                        _c("nx-phone-input", {
                          attrs: {
                            big: false,
                            countries: _vm.countryOptions,
                            "default-country-code":
                              _vm.registrationDetails.country,
                            disabled: _vm.readOnly,
                            "country-select-disabled": true,
                          },
                          on: { validate: _vm.onPhoneValidation },
                          model: {
                            value: _vm.registrationDetails.e164,
                            callback: function ($$v) {
                              _vm.$set(_vm.registrationDetails, "e164", $$v)
                            },
                            expression: "registrationDetails.e164",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("VButton", {
                      attrs: {
                        id: "phone-tooltip-anchor",
                        size: "condensed",
                        appearance: "ghost-light",
                        icon: "help-line",
                        connotation: "accent",
                        shape: "rounded",
                      },
                    }),
                    _c("VTooltip", {
                      staticStyle: { "--tooltip-inline-size": "300px" },
                      attrs: {
                        anchor: "phone-tooltip-anchor",
                        text: _vm.$t("smsRegistrations.phoneTooltip"),
                        placement: "left",
                      },
                    }),
                  ],
                  1
                ),
                _vm.hasTaxId === false
                  ? _c(
                      "div",
                      { staticClass: "tooltip-wrapper-div" },
                      [
                        _c("text-field", {
                          attrs: {
                            "data-cy": "sms-registration-mobile-phone-input",
                            "validation-message": _vm.mobilePhoneErrorMessage,
                            pattern: _vm.regexPatterns.mobilePhoneRegex,
                            value: _vm.registrationDetails.mobilePhone,
                            dense: "",
                            label: _vm.$t("smsRegistrations.mobilePhone"),
                            placeholder: _vm.$t(
                              "smsRegistrations.mobilePhonePlaceholder"
                            ),
                            disabled: _vm.readOnly,
                          },
                          on: {
                            textChanged: function ($event) {
                              _vm.registrationDetails.mobilePhone = $event
                            },
                          },
                        }),
                        _c("VButton", {
                          attrs: {
                            id: "mobile-phone-tooltip-anchor",
                            size: "condensed",
                            appearance: "ghost-light",
                            icon: "help-line",
                            connotation: "accent",
                            shape: "rounded",
                          },
                        }),
                        _c("VTooltip", {
                          staticStyle: { "--tooltip-inline-size": "300px" },
                          attrs: {
                            anchor: "mobile-phone-tooltip-anchor",
                            text: _vm.$t("smsRegistrations.mobilePhoneTooltip"),
                            placement: "left",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "tooltip-wrapper-div" },
                  [
                    _c("text-field", {
                      attrs: {
                        disabled: _vm.readOnly,
                        "data-cy": "sms-registration-email-input",
                        "validation-message": _vm.emailErrorMessage,
                        pattern: _vm.regexPatterns.emailRegex,
                        value: _vm.registrationDetails.email,
                        dense: "",
                        label: _vm.$t("smsRegistrations.email"),
                        placeholder: _vm.$t("smsRegistrations.email"),
                      },
                      on: {
                        textChanged: function ($event) {
                          _vm.registrationDetails.email = $event
                        },
                      },
                    }),
                    _c("VButton", {
                      attrs: {
                        id: "registration-email-tooltip-anchor",
                        size: "condensed",
                        appearance: "ghost-light",
                        icon: "help-line",
                        connotation: "accent",
                        shape: "rounded",
                      },
                    }),
                    _c("VTooltip", {
                      staticStyle: { "--tooltip-inline-size": "300px" },
                      attrs: {
                        anchor: "registration-email-tooltip-anchor",
                        text: _vm.$t("smsRegistrations.emailTooltip"),
                        placement: "left",
                      },
                    }),
                  ],
                  1
                ),
                _c("text-field", {
                  attrs: {
                    disabled: _vm.readOnly,
                    "data-cy": "sms-registration-street-input",
                    value: _vm.registrationDetails.street,
                    dense: "",
                    label: _vm.$t("smsRegistrations.street"),
                    placeholder: _vm.$t("smsRegistrations.street"),
                  },
                  on: {
                    textChanged: function ($event) {
                      _vm.registrationDetails.street = $event
                    },
                  },
                }),
                _c("text-field", {
                  attrs: {
                    disabled: _vm.readOnly,
                    "data-cy": "sms-registration-city-input",
                    value: _vm.registrationDetails.city,
                    dense: "",
                    label: _vm.$t("smsRegistrations.city"),
                    placeholder: _vm.$t("smsRegistrations.city"),
                  },
                  on: {
                    textChanged: function ($event) {
                      _vm.registrationDetails.city = $event
                    },
                  },
                }),
                _c("text-field", {
                  attrs: {
                    disabled: _vm.readOnly,
                    "data-cy": "sms-registration-state-input",
                    "validation-message": _vm.stateErrorMessage,
                    pattern: _vm.statePattern,
                    value: _vm.registrationDetails.state,
                    dense: "",
                    label: _vm.$t("smsRegistrations.state"),
                    placeholder: _vm.$t("smsRegistrations.state"),
                  },
                  on: {
                    textChanged: function ($event) {
                      _vm.registrationDetails.state = $event
                    },
                  },
                }),
                _c("text-field", {
                  attrs: {
                    disabled: _vm.readOnly,
                    "data-cy": "sms-registration-postal-code-input",
                    "validation-message": _vm.zipErrorMessage,
                    pattern: _vm.isCanada
                      ? _vm.regexPatterns.canadaZipPattern
                      : _vm.regexPatterns.zipPattern,
                    value: _vm.registrationDetails.postalCode,
                    dense: "",
                    label: _vm.$t("smsRegistrations.postalCode"),
                    placeholder: _vm.$t("smsRegistrations.postalCode"),
                  },
                  on: {
                    textChanged: function ($event) {
                      _vm.registrationDetails.postalCode = $event
                    },
                  },
                }),
                _c("text-field", {
                  attrs: {
                    disabled: _vm.readOnly,
                    "data-cy": "sms-registration-website-input",
                    "validation-message": _vm.webSiteValidation,
                    pattern: _vm.regexPatterns.webSiteRegex,
                    value: _vm.registrationDetails.website,
                    dense: "",
                    label: _vm.$t("smsRegistrations.website"),
                    placeholder: _vm.$t("smsRegistrations.website"),
                  },
                  on: { textChanged: _vm.onWebsiteTextChanged },
                }),
                _vm.hasTaxId === true
                  ? [
                      _c("div", { staticClass: "entity-type-radio-group" }, [
                        _c("span", [_vm._v("Entity type")]),
                        _c(
                          "div",
                          { staticClass: "radio-options-container" },
                          _vm._l(_vm.entityTypeOptions, function (entityType) {
                            return _c(
                              "div",
                              {
                                key: entityType.value,
                                staticClass: "radio-option",
                              },
                              [
                                _c("vwc-radio", {
                                  attrs: {
                                    id: "entity-type-" + entityType.value,
                                    value: entityType.value,
                                    checked:
                                      entityType.value ===
                                      _vm.registrationDetails.entityType,
                                    disabled: _vm.isEditView || _vm.readOnly,
                                    "data-cy":
                                      "sms-registration-entity-type-" +
                                      entityType.value.toLowerCase(),
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.entityTypeChanged(
                                        entityType.value
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "label",
                                  {
                                    attrs: {
                                      for: "entity-type-" + entityType.value,
                                    },
                                    on: {
                                      click: function ($event) {
                                        !_vm.isEditView &&
                                          _vm.entityTypeChanged(
                                            entityType.value
                                          )
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(entityType.label))]
                                ),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]),
                    ]
                  : _vm._e(),
                _vm.shouldShowStockFields
                  ? [
                      _c(
                        "vwc-select",
                        {
                          staticClass: "text-field",
                          attrs: {
                            disabled: _vm.readOnly,
                            dense: "",
                            required: "",
                            id: "stock-exchange-select",
                            label: _vm.$t("smsRegistrations.stockExchange"),
                            "data-cy": "sms-registration-stock-exchange-select",
                          },
                          on: { selected: _vm.stockExchangeChanged },
                        },
                        _vm._l(
                          _vm.stockExchangeForCountry,
                          function (stockExchange) {
                            return _c(
                              "vwc-list-item",
                              {
                                key: stockExchange.id,
                                attrs: {
                                  value: stockExchange.id,
                                  selected:
                                    stockExchange.id ===
                                    _vm.registrationDetails.stockExchange,
                                  tabindex: "-1",
                                  "aria-disabled": "false",
                                  role: "option",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(stockExchange.description) +
                                    " (" +
                                    _vm._s(stockExchange.id) +
                                    ")"
                                ),
                              ]
                            )
                          }
                        ),
                        1
                      ),
                      _c("text-field", {
                        attrs: {
                          disabled: _vm.readOnly,
                          "data-cy": "sms-registration-stock-symbol",
                          dense: "",
                          required: "",
                          value: _vm.registrationDetails.stockSymbol,
                          label: _vm.$t("smsRegistrations.stockSymbol"),
                          placeholder: _vm.$t("smsRegistrations.stockSymbol"),
                        },
                        on: {
                          textChanged: function ($event) {
                            _vm.registrationDetails.stockSymbol = $event
                          },
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "tooltip-wrapper-div" },
                        [
                          _c("text-field", {
                            ref: "verificationEmail",
                            attrs: {
                              disabled: _vm.readOnly,
                              "data-cy":
                                "sms-registration-business-contact-email",
                              "validation-message":
                                _vm.verificationEmailValidation,
                              pattern: _vm.regexPatterns.emailRegex,
                              value: _vm.registrationDetails.verificationEmail,
                              dense: "",
                              label: _vm.$t(
                                "smsRegistrations.publicProfitEmailLabel"
                              ),
                              placeholder: _vm.$t(
                                "smsRegistrations.publicProfitEmailLabel"
                              ),
                              customValidator: _vm.validateEmailWithDomain,
                            },
                            on: {
                              textChanged: function ($event) {
                                _vm.registrationDetails.verificationEmail =
                                  $event
                              },
                            },
                          }),
                          _c("VButton", {
                            attrs: {
                              id: "business-contact-email-tooltip-anchor",
                              size: "condensed",
                              appearance: "ghost-light",
                              icon: "help-line",
                              connotation: "accent",
                              shape: "rounded",
                            },
                          }),
                          _c("VTooltip", {
                            staticStyle: { "--tooltip-inline-size": "300px" },
                            attrs: {
                              anchor: "business-contact-email-tooltip-anchor",
                              text: _vm.$t(
                                "smsRegistrations.publicProfitEmailTooltip"
                              ),
                              placement: "left",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
                _vm.isAllowToChangeVolume
                  ? _c(
                      "vwc-select",
                      {
                        staticClass: "text-field",
                        attrs: {
                          disabled: _vm.readOnly,
                          "data-cy": "sms-registration-volume-type",
                          required: "",
                          dense: "",
                          label: "Volume Type",
                        },
                        on: { selected: _vm.volumeTypeChanged },
                      },
                      _vm._l(_vm.volumeTypeOptions, function (volumeType) {
                        return _c(
                          "vwc-list-item",
                          {
                            key: volumeType.value,
                            attrs: {
                              selected:
                                volumeType.value ===
                                _vm.registrationDetails.volumeType,
                              value: volumeType.value,
                              tabindex: "-1",
                              "aria-disabled": "false",
                              role: "option",
                            },
                          },
                          [_vm._v(_vm._s(volumeType.label))]
                        )
                      }),
                      1
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }